<template>
    <div>
        <div class="content">
          <lk-card title="患者信息">
            <div>
              <lk-form :label-width='160' label-position='right'>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='患者姓名:'>
                      <span>{{info.patnName}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='7'>
                    <lk-form-item label='年龄:'>
                      <span>{{info.patnAge}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label='性别:'>
                      <span>{{info.gend == 1 ? '男' : '女'}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='7'>
                    <lk-form-item label='过敏史:'>
                      <span>{{info.algsHis}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
      </div>
</template>
<script>

export default {
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      name: '',
      showModal: this.status,
    };
  },
  methods: {
    handleSure() {

    },
  },
};
</script>

<style scoped>
.content {
  padding-top: 20px;
}
</style>